import { useQuery } from '@tanstack/react-query';
import { DirectReportsWidgetApiResponse } from 'abi-lcm-common-types';

import { lcmApi } from '~/shared/services/api';

export const GET_WIDGET_DIRECT_REPORTS_COMPLETION_QUERY_KEY =
  'homeV2/useGetWidgetDirectReportsCompletion';

async function getWidgetDirectReportsCompletion(): Promise<DirectReportsWidgetApiResponse> {
  const { data } = await lcmApi.get<DirectReportsWidgetApiResponse>(
    '/widgets/assessments/direct-report-status'
  );
  return data;
}

export function useGetWidgetDirectReportsCompletion() {
  return useQuery({
    queryKey: [GET_WIDGET_DIRECT_REPORTS_COMPLETION_QUERY_KEY],
    queryFn: getWidgetDirectReportsCompletion,
  });
}
